export default "__VITE_ASSET__DU3Elot6__"